import {
  createFolder as publicCreateFolder,
  getFolder as publicGetFolder,
  listFolders as publicListFolders,
  searchFolders as publicSearchFolders,
  updateFolder as publicUpdateFolder,
  generateFolderDownloadUrl as publicGenerateFolderDownloadUrl,
  bulkDeleteFolders as publicBulkDeleteFolders,
  bulkRestoreFoldersFromTrashBin as publicBulkRestoreFoldersFromTrashBin,
  listDeletedFolders as publicListDeletedFolders,
  queryFolders as publicQueryFolders,
  typedQueryFolders as publicTypedQueryFolders,
} from './media-site-media-v1-folder-folders.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  FolderQuery,
  FoldersQueryBuilder,
  typedQueryFolders as universalTypedQueryFolders,
} from './media-site-media-v1-folder-folders.universal.js';

function customQueryFolders(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryFolders(httpClient)(),
    typedQueryFunction: (query: FolderQuery) =>
      publicTypedQueryFolders(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): FoldersQueryBuilder;
  function overloadedQuery(
    query: FolderQuery
  ): ReturnType<typeof universalTypedQueryFolders>;
  function overloadedQuery(query?: FolderQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createFolder: MaybeContext<
  BuildRESTFunction<typeof publicCreateFolder> & typeof publicCreateFolder
> = /*#__PURE__*/ createRESTModule(publicCreateFolder);
export const getFolder: MaybeContext<
  BuildRESTFunction<typeof publicGetFolder> & typeof publicGetFolder
> = /*#__PURE__*/ createRESTModule(publicGetFolder);
export const listFolders: MaybeContext<
  BuildRESTFunction<typeof publicListFolders> & typeof publicListFolders
> = /*#__PURE__*/ createRESTModule(publicListFolders);
export const searchFolders: MaybeContext<
  BuildRESTFunction<typeof publicSearchFolders> & typeof publicSearchFolders
> = /*#__PURE__*/ createRESTModule(publicSearchFolders);
export const updateFolder: MaybeContext<
  BuildRESTFunction<typeof publicUpdateFolder> & typeof publicUpdateFolder
> = /*#__PURE__*/ createRESTModule(publicUpdateFolder);
export const generateFolderDownloadUrl: MaybeContext<
  BuildRESTFunction<typeof publicGenerateFolderDownloadUrl> &
    typeof publicGenerateFolderDownloadUrl
> = /*#__PURE__*/ createRESTModule(publicGenerateFolderDownloadUrl);
export const bulkDeleteFolders: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteFolders> &
    typeof publicBulkDeleteFolders
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteFolders);
export const bulkRestoreFoldersFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicBulkRestoreFoldersFromTrashBin> &
    typeof publicBulkRestoreFoldersFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicBulkRestoreFoldersFromTrashBin);
export const listDeletedFolders: MaybeContext<
  BuildRESTFunction<typeof publicListDeletedFolders> &
    typeof publicListDeletedFolders
> = /*#__PURE__*/ createRESTModule(publicListDeletedFolders);
export const queryFolders: MaybeContext<
  BuildRESTFunction<typeof customQueryFolders> & typeof customQueryFolders
> = /*#__PURE__*/ createRESTModule(customQueryFolders);

export {
  State,
  Namespace,
  CommonSortOrder,
  RootFolder,
  SortOrder,
  WebhookIdentityType,
} from './media-site-media-v1-folder-folders.universal.js';
export {
  Folder,
  CreateFolderRequest,
  CreateFolderResponse,
  GetFolderRequest,
  GetFolderResponse,
  ListFoldersRequest,
  CommonSorting,
  AddressLocation,
  CursorPaging,
  ListFoldersResponse,
  PagingMetadataV2,
  Cursors,
  SearchFoldersRequest,
  SearchFoldersResponse,
  UpdateFolderRequest,
  UpdateFolderResponse,
  UnsupportedRequestValueError,
  GenerateFolderDownloadUrlRequest,
  GenerateFolderDownloadUrlResponse,
  BulkDeleteFoldersRequest,
  BulkDeleteFoldersResponse,
  BulkRestoreFoldersFromTrashBinRequest,
  BulkRestoreFoldersFromTrashBinResponse,
  ListDeletedFoldersRequest,
  ListDeletedFoldersResponse,
  QueryFoldersRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  QueryFoldersResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateFolderOptions,
  ListFoldersOptions,
  SearchFoldersOptions,
  UpdateFolder,
  BulkDeleteFoldersOptions,
  ListDeletedFoldersOptions,
  FoldersQueryResult,
  FoldersQueryBuilder,
  FolderQuerySpec,
} from './media-site-media-v1-folder-folders.universal.js';
export { utils } from './media-site-media-v1-folder-folders.universal.js';
export {
  StateWithLiterals,
  NamespaceWithLiterals,
  CommonSortOrderWithLiterals,
  RootFolderWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateFolderValidationErrors,
  CommonQueryWithEntityContext,
  FolderQuery,
} from './media-site-media-v1-folder-folders.universal.js';
